var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406 120",
    width: 406,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GetItOnGooglePlay_Badge_Web_color_English") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: 0;fill: #ffffff } \n\t\t.s1 { fill: #000000 } \n\t\t.s2 { fill: #a6a6a6 } \n\t\t.s3 { fill: #ffffff;stroke: #ffffff;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s4 { fill: #ffffff } \n\t\t.s5 { fill: #ea4335 } \n\t\t.s6 { fill: #fbbc04 } \n\t\t.s7 { fill: #4285f4 } \n\t\t.s8 { fill: #34a853 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m436-30v180h-465v-180z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m391 120h-375c-8.2 0-15-6.8-15-15v-90c0-8.3 6.8-15 15-15h375c8.3 0 15 6.7 15 15v90c0 8.2-6.7 15-15 15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m406 15v90c0 8.3-6.7 15-15 15h-375c-8.2 0-15-6.7-15-15v-90c0-8.2 6.8-15 15-15h375c8.3 0 15 6.8 15 15zm-390-12.6c-6.9 0-12.6 5.7-12.6 12.6v90c0 6.9 5.7 12.6 12.6 12.6h375c6.9 0 12.6-5.7 12.6-12.6v-90c0-6.9-5.7-12.6-12.6-12.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m143.3 30.7q0 3.8-2.3 6-2.5 2.7-6.6 2.7-3.9 0-6.6-2.7-2.7-2.7-2.7-6.7 0-4 2.7-6.7 2.7-2.7 6.6-2.7 1.9 0 3.7 0.8 1.8 0.7 2.8 2l-1.6 1.5q-1.8-2.1-4.9-2.1-2.8 0-4.9 2-2.1 2-2.1 5.2 0 3.2 2.1 5.2 2.1 2 4.9 2 3 0 5-2 1.3-1.3 1.5-3.7h-6.5v-2.1h8.7q0.2 0.7 0.2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m157.1 23.2h-8.2v5.7h7.4v2.2h-7.4v5.7h8.2v2.2h-10.5v-18h10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m166.8 39h-2.3v-15.8h-5v-2.2h12.4v2.2h-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m183.1 21v18h-2.3v-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m193.4 39h-2.3v-15.8h-5.1v-2.2h12.4v2.2h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m221.8 36.7q-2.6 2.7-6.6 2.7-3.9 0-6.6-2.7-2.6-2.8-2.6-6.7 0-3.9 2.6-6.7 2.7-2.7 6.6-2.7 4 0 6.6 2.7 2.7 2.8 2.7 6.7 0 3.9-2.7 6.7zm-11.5-1.5q2 2 4.9 2 2.9 0 4.9-2 2-2.1 2-5.2 0-3.1-2-5.2-2-2-4.9-2-2.9 0-4.9 2-2 2.1-2 5.2 0 3.1 2 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m227.7 39v-18h2.8l8.8 14h0.1l-0.1-3.5v-10.5h2.3v18h-2.4l-9.2-14.7h-0.1l0.1 3.5v11.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m205.4 90.8c-7.1 0-12.8-5.7-12.8-12.8 0-7 5.7-12.7 12.8-12.7 7.1 0 12.8 5.7 12.8 12.7 0 7.1-5.7 12.8-12.8 12.8zm7.2-12.8c0-4.3-3.2-7.7-7.2-7.7-4 0-7.2 3.4-7.2 7.7 0 4.3 3.2 7.7 7.2 7.7 4 0 7.2-3.4 7.2-7.7zm-35.1 12.8c-7.1 0-12.8-5.7-12.8-12.8 0-7 5.7-12.7 12.8-12.7 7.1 0 12.8 5.7 12.8 12.7 0 7.1-5.7 12.8-12.8 12.8zm7.2-12.8c0-4.3-3.3-7.7-7.2-7.7-4 0-7.2 3.4-7.2 7.7 0 4.3 3.2 7.7 7.2 7.7 3.9 0 7.2-3.4 7.2-7.7zm-22.2-8.8c0.1 0.9 0.2 2.1 0.2 3.4 0 4-1.1 9-4.6 12.6-3.5 3.6-8 5.6-13.9 5.6-10.9 0-20.1-8.9-20.1-19.8 0-11 9.2-19.9 20.1-19.9 6.1 0 10.4 2.4 13.6 5.5l-3.8 3.8c-2.3-2.2-5.5-3.8-9.8-3.8-7.9 0-14.2 6.4-14.2 14.4 0 7.9 6.3 14.4 14.2 14.4 5.2 0 8.2-2.1 10-4 1.6-1.5 2.6-3.8 3-6.8h-13v-5.4zm118.3 5.6l-17 7.1c1.3 2.5 3.3 3.8 6.1 3.8 2.9 0 4.9-1.4 6.3-3.5l4.4 2.9c-1.4 2.1-4.8 5.7-10.7 5.7-7.2 0-12.6-5.6-12.6-12.8 0-7.6 5.4-12.7 12-12.7 6.6 0 9.9 5.2 10.9 8.1zm-6.5-2c-0.7-1.6-2.6-2.7-4.8-2.7-2.8 0-6.8 2.5-6.6 7.5zm-19.7-20.4v37.5h-5.6v-37.5zm-14.8 13.5h5.3v22.9c0 9.4-5.6 13.3-12.1 13.3-6.2 0-9.9-4.1-11.3-7.5l4.8-2.1c0.9 2.1 3 4.6 6.5 4.6 4.2 0 6.8-2.6 6.8-7.5v-1.8h-0.2c-1.3 1.5-3.7 2.9-6.7 2.9-6.4 0-12.2-5.6-12.2-12.8 0-7.2 5.8-12.8 12.2-12.8 3 0 5.4 1.4 6.7 2.9h0.2zm0.4 12c0-4.3-3.1-7.8-7-7.8-3.8 0-6.9 3.5-6.9 7.8 0 4.3 3.1 7.7 6.9 7.7 3.9 0 7-3.4 7-7.7zm78.6-13.9c0 7.2-6.1 11.7-12.3 11.7h-7.8v14.2h-5.6v-37.5h13.4c6.2 0 12.3 4.5 12.3 11.6zm-5.6 0c0-3-2.4-6.4-6.6-6.4h-7.9v12.8h7.9c4.2 0 6.6-3.5 6.6-6.4zm39.4 11.4v14.4h-5.4v-2.9h-0.2c-1.3 2-3.3 3.7-7.1 3.7-4.9 0-9.3-3.3-9.3-8.3 0-5.5 5.4-8.4 10.8-8.4 2.6 0 4.8 0.8 5.8 1.4v-0.4c0-3-3-4.8-5.9-4.8-2 0-4 0.7-5.1 2.8l-4.9-2.1c1.7-4 5.9-5.7 9.9-5.7 6.5 0 11.4 3.7 11.4 10.3zm-5.4 4.3c-1.5-0.8-2.6-1.3-5.1-1.3-2.7 0-5.9 1.1-5.9 4 0 2.3 2.5 3.2 4.4 3.2 3.2 0 6.2-2.5 6.6-5.9zm31.3-13.8l-15.4 35.3h-5.8l5.7-12.6-10-22.7h6l6.7 16.2h0.2l6.4-16.2zm-51-13.5v37.5h-5.6v-37.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m63.2 58.3l-32 33.9q0 0 0 0c1 3.7 4.4 6.4 8.3 6.4 1.6 0 3.1-0.4 4.4-1.2l0.1-0.1 36-20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m95.5 52.5h-0.1l-15.5-9-17.5 15.5 17.6 17.6 15.4-8.9c2.7-1.5 4.6-4.3 4.6-7.6 0-3.3-1.9-6.1-4.5-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m31.2 27.8q-0.3 1.1-0.3 2.3v59.9q0 1.1 0.3 2.2l33.1-33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m63.4 60l16.5-16.5-35.9-20.8c-1.3-0.8-2.8-1.3-4.5-1.3-3.9 0-7.3 2.7-8.3 6.4q0 0 0 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGoogle);
export default __webpack_public_path__ + "static/media/DownloadGoogle.1c6b17bca240118a7f46ca8d79d5807b.svg";
export { ForwardRef as ReactComponent };